import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalTitle: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.Title',
    defaultMessage: 'Prepare Execution',
  },
  cancel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.Cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.Save',
    defaultMessage: 'Save',
  },
  description: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.Description',
    defaultMessage:
      'Please enter the following information before submitting this Voucher to TRACS.',
  },
  nameLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.NameLabel',
    defaultMessage: 'Name',
  },
  titleLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.TitleLabel',
    defaultMessage: 'Title',
  },
  voucherIdLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.VoucherIdLabel',
    defaultMessage: 'Voucher ID',
  },
  voucherIdTooltip: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.VoucherIdTooltip',
    defaultMessage:
      'ID # auto-populates on first submission. If resubmitting, you MUST enter the Voucher ID from the CA/HUD.',
  },
  streetAddressLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.StreetAddressLabel',
    defaultMessage: 'Street Address',
  },
  cityLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.CityLabel',
    defaultMessage: 'City',
  },
  stateLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.StateLabel',
    defaultMessage: 'State',
  },
  zipCodeLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.ZipCodeLabel',
    defaultMessage: 'Zip',
  },
  phoneNumberLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.PhoneNumberLabel',
    defaultMessage: 'Phone Number',
  },
  dateLabel: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.DateLabel',
    defaultMessage: 'Date',
  },
  phoneNumberError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.PhoneNumberError',
    defaultMessage: 'Please enter a valid phone number',
  },
  nameMaxLengthError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.NameMaxLengthError',
    defaultMessage: 'Name must be 50 characters or less',
  },
  nameInvalidCharsError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.NameInvalidCharsError',
    defaultMessage:
      'Name can only contain letters, spaces, hyphens, and periods',
  },
  titleMaxLengthError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.TitleMaxLengthError',
    defaultMessage: 'Title must be 50 characters or less',
  },
  titleInvalidCharsError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.TitleInvalidCharsError',
    defaultMessage:
      'Title can only contain letters, spaces, and the following characters: & - / .',
  },
  zipCodeError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.ZipCodeError',
    defaultMessage: 'Zip must be exactly 5 digits',
  },
  dateError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.DateError',
    defaultMessage:
      'Date must be on or after the first day of the voucher month and cannot be in the future',
  },
  dateBeforeLastSubmissionError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.DateBeforeLastSubmissionError',
    defaultMessage: 'Date must be after last submission date.',
  },
  dateAfterTodayError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.DateAfterTodayError',
    defaultMessage: 'Date must not be in the future.',
  },
  voucherIdError: {
    id: 'App.ManageHudVoucherDetails.ReviewAndSubmitVoucher.PrepareExecutionModal.VoucherIdError',
    defaultMessage: 'Voucher ID must be different than {defaultVoucherId}.',
  },
});

export default messages;
